(function () {
  'use strict';
  var config = window.alunirVipGate;
  var gate = document.getElementById('AlVipGate');
  if (!config || !gate) return;
  var form = gate.querySelector('[data-vip-login]');
  var input = gate.querySelector('[data-vip-password]');
  var error = gate.querySelector('[data-vip-error]');
  var dialog = gate.querySelector('dialog');
  var trigger = gate.querySelector('[data-vip-signup-trigger]');
  var close = dialog.querySelector('[data-vip-close]');
  var success = dialog.querySelector('[data-vip-success]');
  var host = dialog.querySelector('[data-vip-form-host]');
  var intro = dialog.querySelector('[data-vip-form-intro]');
  var mounted = false;
  var popupAttempted = false;
  var grantedInMemory = false;
  function resizeShop() {
    if (window.requestAnimationFrame && window.dispatchEvent) window.requestAnimationFrame(function () { window.dispatchEvent(new Event('resize')); });
  }
  function locked() { return document.documentElement.classList.contains('al-vip-locked'); }
  function closeSignup() { if (dialog.open) dialog.close(); }
  function openSignup() {
    if (!locked()) return;
    if (!mounted) {
      var template = gate.querySelector('[data-vip-form-template]');
      if (host && template) host.appendChild(template.content.cloneNode(true));
      mounted = true;
    }
    if (!dialog.open) dialog.showModal();
  }
  function refresh() {
    var now = Date.now();
    var wasLocked = locked();
    var shouldLock = config.isActive(now) && !grantedInMemory && !config.hasAccess(now);
    document.documentElement.classList.toggle('al-vip-locked', shouldLock);
    gate.setAttribute('aria-hidden', shouldLock ? 'false' : 'true');
    if (!shouldLock) { closeSignup(); if (wasLocked) resizeShop(); return; }
    if (config.autoPopup && config.formId && !popupAttempted) {
      popupAttempted = true;
      var seen = false;
      try { seen = sessionStorage.getItem(config.storageKey + '-popup') === '1'; } catch (ignored) {}
      if (!seen) {
        openSignup();
        try { sessionStorage.setItem(config.storageKey + '-popup', '1'); } catch (ignored) {}
      }
    }
  }
  async function unlock(value) {
    error.hidden = true;
    if (!config.configured || !config.isActive(Date.now())) return false;
    try {
      var bytes = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value.trim()));
      var hash = Array.from(new Uint8Array(bytes)).map(function (b) { return b.toString(16).padStart(2,'0'); }).join('');
      if (hash !== config.passwordHash) { error.hidden = false; input.setAttribute('aria-invalid','true'); input.focus(); return false; }
      grantedInMemory = true;
      try { localStorage.setItem(config.storageKey, JSON.stringify({hash:hash, expires:config.endTime})); } catch (ignored) {}
      // Der aktuelle Seitenzugang funktioniert auch bei blockiertem Browserspeicher.
      closeSignup();
      gate.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('al-vip-locked');
      resizeShop();
      input.value = '';
      input.removeAttribute('aria-invalid');
      var main = document.getElementById('MainContent');
      if (main) { main.setAttribute('tabindex','-1'); main.focus({preventScroll:true}); }
      return true;
    } catch (failure) { error.hidden = false; return false; }
  }
  form.addEventListener('submit', function (event) { event.preventDefault(); unlock(input.value); });
  trigger.addEventListener('click', openSignup);
  close.addEventListener('click', function () { closeSignup(); trigger.focus(); });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    var r = dialog.getBoundingClientRect();
    if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeSignup();
  });
  window.addEventListener('klaviyoForms', function (event) {
    var detail = event.detail;
    if (!locked() || !detail || detail.type !== 'submit' || !config.formId || detail.formId !== config.formId || !config.configured) return;
    if (host) host.hidden = true;
    if (intro) intro.hidden = true;
    success.hidden = false;
    success.focus();
  });
  dialog.querySelector('[data-vip-use-password]').addEventListener('click', function () {
    var password = success.querySelector('[data-vip-revealed-password]').textContent.trim();
    closeSignup();
    input.value = password;
    input.focus();
  });
  window.addEventListener('storage', refresh);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.setInterval(refresh, 30000);
  var untilEnd = config.endTime - Date.now();
  if (!config.preview && untilEnd > 0 && untilEnd <= 2147483647) window.setTimeout(refresh, untilEnd + 20);
  var untilStart = config.startTime - Date.now();
  if (!config.preview && untilStart > 0 && untilStart <= 2147483647) window.setTimeout(refresh, untilStart + 20);
  config.unlock = unlock;
  config.refresh = refresh;
  refresh();
})();
